module.exports = __webpack_public_path__ + "static/media/cafe_v_salon_2.432203a4.png";